import React from 'react';

class CrossJoinRenderer {
  constructor(userInteraction) {
    this.userInteraction = userInteraction;
  }

  textAlignCenter() {
    return false;
  }

  keys() {
    return ['KEY'];
  }

  valueToKeyMapper() {
    return 'KEY';
  }

  valueSortFunc(a, b) {
    return a
      .foreignColumn()
      .tov()
      .name()
      .localeCompare(b.foreignColumn().tov().name());
  }

  optionClicked(fk) {
    const props = { section: 'selectJoin', fk };
    return this.userInteraction(props);
  }

  renderKey() {
    return '*';
  }

  renderValue(fk) {
    return <span>{fk.foreignColumn().tov().name()} (on * = *)</span>;
  }
}

export default CrossJoinRenderer;
